import React,{ PureComponent } from 'react'
import {Select,Spin} from 'antd';
import PropTypes from 'prop-types';
import SearchFromService from "../SearchForm/SearchFrom.action";
const { Option } = Select;

/**
 * 搜索 下拉
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 *
 *
 * @param title 标题
 * @param initValue: PropTypes.string, 打开显示文本
 * @param api 查询URL
 * @param searchField (当前搜索字段名)
 * @param onChange: PropTypes.func  回调选择项{ id}  { id,value } ,在getFieldDecorator 或者表单隐含此方法的包含中可忽略配置此项
 *
 * pageSize 搜索行数

 * field 显示文本字段名 :
 *    * field 传string 栏目增加一列名称, 如 field:  'typeName',
 *    * 传array栏目增加array数组 ,默认显示配置的第一列, 如field:  [{ title: '名称',dataIndex:'i18nKeyword'},{ title: '类型', dataIndex:'typeName'}], //todo 后续可优化
 *
 * disabled 是否不可编辑
 * idField 编号字段名称(回调值) 默认id，
 * precondition 前置条件
 * initFirstOne 配置 第一个回来的数组为默认值
 *
 * initListFlag 是否初始化一页数据, 默认 false
 *
 * getSelectedItem 供外部调，回调当前选择项
 *
 * 扩展：
 **/
class CommonSelect extends PureComponent{
    static propTypes = {
        api: PropTypes.string.isRequired,
        onChange: PropTypes.func,
        nameField:  PropTypes.any,
        idField: PropTypes.string,
        allowClear: PropTypes.bool,
        precondition:PropTypes.object,
        initFirstOne: PropTypes.bool,
    }
    static defaultProps = {
        api:'',
        nameField:'name',
        idField:'id',
        type:"",
        allowClear:true,
        precondition:{},
        initFirstOne:false
    };
    constructor(props){
        super(props)
        this.state = {
            loading:false,
            items:[]
        }
    }
    /**
     * 搜索
     * @param api 查询的接口
     */
    onInitFetch() {
        const { api, list,precondition={}} = this.props;
        if(api){
            SearchFromService.fetch(api,{...precondition}).then((resp)=>this.showInitResult(resp.data));
        }else {
            const data = {
                models:list,
                success:true,
                valid:true
            }
            this.showInitResult(data)
        }
    }
    /**
     * 赋值处理
     */
    showInitResult = (result={}) =>{
        if(result.success&&result.valid){
            let models = result.models || [],initFirstValue="";
            const {idField,nameField,initFirstOne} = this.props;
            models.forEach((item,inxdex)=>{
                if(initFirstOne&&inxdex==0&&item[idField]){
                    initFirstValue = item[idField];
                }
                item["id"] = item[idField];
                item["name"] = item[nameField];
            });
            if(initFirstOne&&initFirstValue){
                this.singleSearch(initFirstValue)
                this.setState({
                    initFirstValue : initFirstValue,
                    loading:true
                },()=>{
                    this.setState({
                        items: models,
                        loading:false
                    })
                })
            }else this.setState({
                items: models,
                loading:false
            })

        }
    }
    /**
     * 单独搜索
     *
     **/
    singleSearch(data,){
        // let { currSearch={} }= this.state;
        // currSearch[key] = data;
        // this.setState({
        //     currSearch : currSearch
        // })
        this.props.onChange(data);
        if(this.props.onOtherChange)this.props.onOtherChange(data);
    }
    /**
     * 输出select
     * */
    getOptions(list=[],type){
        const enumChildren = [];
        list.forEach(item=>{
            const iconUrl = type=="abbreviate"&&item.abbreviate?require('../../assets/img/country/'+item.abbreviate + '.png'):"";
           enumChildren.push(<Option key={item.id} value={item.id}>
                {iconUrl?<img src={iconUrl.default} height={10.5} className={"mr_8"} />:null}
               {item.name}</Option>)
        });
        return enumChildren;
    }
    componentDidMount(){
        this.onInitFetch();
        if( this.props.onRef)this.props.onRef(this);
    }
    render() {
        const { placeholder,initValue,type,allowClear=true,width } = this.props;
        const { items,initFirstValue,loading=false } = this.state;
        return (<Spin spinning={loading}>
            {!loading?<Select placeholder={placeholder}
                              defaultValue={initValue||initFirstValue}
                              allowClear={allowClear?< i class="ri-close-line"></i>:false}
                              style={width?{width:width+"px"}:{}}
                              onChange={(value)=>{this.singleSearch(value)}} >
                {this.getOptions(items,type)}
            </Select>:null}
        </Spin> )
    }
}


export default CommonSelect;
